var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAllTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/alltime"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.721875,6.99999999 C14.65625,6.99999999 13.040625,8.29062499 12,9.45624999 C10.959375,8.29062499 9.34374999,6.99999999 7.27812499,6.99999999 C4.36874998,6.99999999 1.99999997,9.24374999 1.99999997,12 C1.99999997,14.75625 4.36874998,17 7.27812499,17 C9.34374999,17 10.959375,15.709375 12,14.54375 C13.040625,15.709375 14.65625,17 16.721875,17 C19.63125,17 22,14.75625 22,12 C22,9.24374999 19.63125,6.99999999 16.721875,6.99999999 Z M7.27812499,14 C6.02187499,14 4.99999998,13.103125 4.99999998,12 C4.99999998,10.896875 6.02187499,9.99999999 7.27812499,9.99999999 C8.47187499,9.99999999 9.57187499,11.128125 10.215625,12 C9.57812499,12.8625 8.46874999,14 7.27812499,14 Z M16.721875,14 C15.528125,14 14.428125,12.871875 13.784375,12 C14.421875,11.1375 15.53125,9.99999999 16.721875,9.99999999 C17.978125,9.99999999 19,10.896875 19,12 C19,13.103125 17.978125,14 16.721875,14 Z",
    id: "infinity"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllTime);
export default __webpack_public_path__ + "static/media/iconAllTime.e3cb91aa.svg";
export { ForwardRef as ReactComponent };